export type OPERATION_ACTIONS = 'VALIDATE' | 'CANCEL';
